import { getLocation } from './ssrCompatible'
import { isLocalIp } from './env'

// 给上传到fds的图片加webp格式
export function formatFDSImageWebp(url = '') {
  if (window.supportWebp) {
    if (url && url.indexOf('.fds.') > -1) {
      if (url.indexOf('?') === -1) {
        return `${url.trim()}?f=webp&q=50`
      } else {
        return `${url.trim()}&f=webp&q=50`
      }
    } else {
      // return formatImageWebp(url)
      return url
    }
  }
  return url
}

// 给本地图片设置webp格式: 只针对png和jpg图片格式进行webp兼容处理
export function formatImageWebp(url = '') {
  // 本地开发环境不转webp
  const curHost = getLocation().host
  if (curHost.indexOf('localhost') > -1 || isLocalIp()) {
    return url
  }
  if (url.indexOf('toplupe.com') > -1) {
    return url
  }
  const isWebp = url && url.indexOf('.webp') > -1
  if (!window.supportWebp || isWebp) {
    return url
  }
  const isPng = url && url.indexOf('.png') > -1
  const isJpg = url && url.indexOf('.jpg') > -1
  const isQuery = url && url.indexOf('?') === -1
  if (isQuery) {
    if (isPng || isJpg) {
      return `${url.trim()}.webp`
    }
  } else {
    if (isPng) {
      return url.replace('.png', '.png.webp')
    }
    if (isJpg) {
      return url.replace('.jpg', '.jpg.webp')
    }
  }
  return url
}

//判断浏览器是否支持webp格式
export function checkWebPSupport() {
  return new Promise((resolve, reject) => {
    if (process.client) {
      const img = new Image()
      img.onload = function () {
        if (img.width > 0 && img.height > 0) {
          resolve(true)
        } else {
          reject(false)
        }
      }
      img.onerror = function () {
        reject(false)
      }
      img.src = `data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=`
    } else {
      resolve(false)
    }
  })
}

// 不走懒加载、直接进行webp的压缩
export async function compressWebp(url = '') {
  const result = await checkWebPSupport()
  if (!result) return url

  if (url && url.indexOf('.fds.') > -1) {
    let fix = url.indexOf('?') === -1 ? '?' : '&'
    return `${url.trim()}${fix}f=webp&q=50`
  }
  return url
}

// 压缩当前的banner的图片不走懒加载
export async function compressBannerImg(banners) {
  if (banners && banners.length) {
    return await Promise.all(
      banners.map(async (item) => {
        item.picture = await compressWebp(item.picture)
        return item
      })
    )
  }
  return banners || []
}
